var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueScriptComponent',{attrs:{"script":"<script async src=\"https://telegram.org/js/telegram-widget.js?11\" data-telegram-login=\"SwisetBot\" data-size=\"medium\" data-auth-url=\"https://app.swiset.com/telegram\" data-request-access=\"write\"></script>"}})
}
var staticRenderFns = []

export { render, staticRenderFns }